import { render, staticRenderFns } from "./sendmessage.html?vue&type=template&id=f5fa5ba6&scoped=true&external"
import script from "./sendmessage.vue?vue&type=script&lang=js"
export * from "./sendmessage.vue?vue&type=script&lang=js"
import style0 from "./sendmessage.vue?vue&type=style&index=0&id=f5fa5ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fa5ba6",
  null
  
)

export default component.exports